
// @ts-nocheck





import { i18nText } from '@/locales';


import {Component, Vue, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import { FormModel, message, notification } from "ant-design-vue";
import moment from "moment";
import {SalonsStore} from "@/store/modules/Salons";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {RouterNameEnum} from "@/router/router.types";
import {AppStateStore} from "@/store/modules/appState";
import CreateFormSalon from "@/UI/pages/salons/components/CreateFormSalon.vue"
import { SalonForm } from "../lib/SalonForm";
import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
import { SendSalonData } from "@/UI/pages/salons/lib/SalonTypes";

@Component({
    components: {
        BaseDataForm,
        CreateFormSalon,
        PageTitle,
    },
})
export default class CreateStudio extends mixins( SimpleProxyForm, ProxyTableData ) {
    form = new SalonForm()
    showModal = false;
    isAllowToSave = false

    cancelAction() {
        Vue.router.push({name: RouterNameEnum.Salons, params: {Studio: '0'}});
    }

    @Watch('form', { immediate: false, deep: true })
    allowSave(): void {
        if (this.$refs.studioForm !== undefined && this.form.salon_name) {
            ((this.$refs.studioForm as any).$refs.studioForm as FormModel).validate((valid) => {
                if (valid) {
                    this.isAllowToSave = true;
                } else if(this.isAllowToSave) {
                  this.isAllowToSave = false;
                }
            });
        }
    }

    errorWarningField(field, error) {
        const elements = document.querySelector(`.${field}`).querySelectorAll('input')
        elements.forEach(element => {
            element.classList.add('error-border');
        });
        this.$notification.error({
            message: i18nText("Проверьте поля на правильность заполнения"),
            description: `${error ? error : ''}`,
            duration: 0,
        })
    }

    deleteErrorBorders(errorElements) {
        errorElements.forEach(element => {   
            element.classList.remove('error-border');
        });
    }

    submitAction(): void {
        const errorElements = document.querySelectorAll('.error-border');
        if(errorElements && errorElements.length) this.deleteErrorBorders(errorElements);
        // ----- solving 00:00 default value beight invalid date (Starting line.) -----
        let work_time_from : string;
        let work_time_to : string;
        if (moment(this.form.work_time_from).format('HH:mm') === 'Invalid date') {
            work_time_from = "00:00";
        }
        else {
            work_time_from = moment(this.form.work_time_from).format('HH:mm');
        }

        if (moment(this.form.work_time_to).format('HH:mm') === 'Invalid date') {
            work_time_to = "00:00";
        }
        else {
            work_time_to = moment(this.form.work_time_to).format('HH:mm');
        }

        // ----- solving 00:00 default value beight invalid date (Ending line.) -----
        
        if (work_time_from >= work_time_to) {
            // ----- makeTimeInputsRedBordered (Starting line.) -----
            function makeTimeInputsRedBordered() {
                document.querySelector('.work_time-inputs').querySelectorAll('input').forEach((element) => { 
                    element.classList.add('error-border');
                 });
            }
            for (let i = 0; i <4; i++){
                setTimeout(() => {
                    makeTimeInputsRedBordered();
                }, 500 * i);
            }
            // ----- makeTimeInputsRedBordered (Ending line.) ----
            this.$notification.error({
                message: i18nText("Проверьте поля на правильность заполнения"),
                description: i18nText("Время окончания работы должно быть позже времени начала работы"),
                duration: 0,
            })
             return;
        }
        if (this.form.legal_entity_data_INN && this.form.legal_entity_data_INN.length > 30) {
            this.errorWarningField('legal_entity_data_INN', i18nText("Поле ИНН должно содержать не более 30 символов"))
             return;
        }
        if (this.form.legal_entity_data_KPP && this.form.legal_entity_data_KPP.length > 30) {
            this.errorWarningField('legal_entity_data_KPP', i18nText("Поле КПП должно содержать не более 30 символов"))
             return;
        }
        if (this.form.account_RCBIC && this.form.account_RCBIC.length > 30) {
            this.errorWarningField('account_RCBIC', i18nText("Поле БИК должно содержать не более 30 символов"))
             return;
        }
        if (this.form.correspondent_account && this.form.correspondent_account.length > 30) {
            this.errorWarningField('correspondent_account', i18nText("Поле Корр. счет должно содержать не более 30 символов"))
             return;
        }
        if (this.form.checking_account && this.form.checking_account.length > 30) {
            this.errorWarningField('checking_account', i18nText("Поле Расчетный счет должно содержать не более 30 символов"))
             return;
        }

        ((this.$refs.studioForm as any).$refs.studioForm as FormModel).validate((valid) => {
            if (valid) {
                let data: SendSalonData = {
                    id: this.form.id,
                    ...(this.form.company_id ? {company_id: this.form.company_id} : {}),
                    active: !!this.form.active,
                    salon_name: this.form.salon_name,
                    city_id: this.form.city_id,
                    partner: {
                        name: this.form.partner_name,
                        phone: this.form.partner_phone,
                        email: this.form.partner_email,
                        social_network: this.form.partner_social_network,
                    },
                    opening_date: this.form.opening_date,
                    work_time_from: work_time_from,
                    work_time_to: work_time_to,
                    phone: this.form.phone,
                    address: this.form.address,
                    social_network_link: this.form.social_network_link,
                    salon_group_id: this.form.salon_group_id,
                    conclusion_contract_date: this.form.conclusion_contract_date,
                    currency_id: this.form.currency_id,
                    legal_entity_data: {
                      name: this.form.legal_entity_name,
                      legal_address: this.form.legal_address,
                      INN: this.form.legal_entity_data_INN,
                      KPP: this.form.legal_entity_data_KPP,
                      account: {
                        RCBIC: this.form.account_RCBIC,
                        bank_name: this.form.bank_name,
                        correspondent_account: this.form.correspondent_account,
                        checking_account: this.form.checking_account,
                      }
                    },
                    transfer: this.form.transfer,
                }

                try {   
                    SalonsStore.create(data as any).then((response) => {
                        if (response.status) {
                            notification.success({
                                message: i18nText("Операция успешно выполнена"),
                                description: response["response"],
                                duration: 10
                            });
                            Vue.router.push({name: RouterNameEnum.Salons, params: {Studio: '0'}});
                            AppStateStore.setProxy(true);
                            message.info(i18nText("Студия создана"));
                        } else {
                            notification.error({
                                message: i18nText("Возникла ошибка"),
                                description: response["response"],
                                duration: 10
                            })
                        }
                    })
                } catch (e) {
                    console.error(e)
                    message.error(i18nText("Ошибка создания студии"));
                }
            }
        })
    }

    async created(): Promise<void> {
        this.formReady = false
        try {
            await this.fetchModule([
                {s: 'territory'},
                {s: 'currency'},
                ...(Vue.auth.check('admin') ? [{s: 'groups'}] : [])
            ])
        } catch (e) {
            console.log(e);
        } finally {
            this.formReady = true;
        }
    }
}
